"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var CreateTypeButton = function (_a) {
    var InputProps = _a.InputProps, Icon = _a.Icon, isEnabled = _a.isEnabled, onChange = _a.onChange, children = _a.children, _b = _a.disabled, disabled = _b === void 0 ? false : _b;
    var classes = InputProps.classes;
    var theme = core_1.useTheme();
    return (react_1.default.createElement(core_1.Button, { variant: isEnabled ? 'text' : 'contained', className: classes.linkTypeButton + " " + (isEnabled ? '' : classes.linkTypeButtonEnabled), onClick: onChange, disabled: disabled },
        react_1.default.createElement(Icon, { color: theme.palette.primary.dark }),
        react_1.default.createElement(core_1.Typography, { variant: "body2", className: classes.linkTypeButtonText }, children)));
};
exports.default = CreateTypeButton;
